"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const services_1 = require("../../common/services");
const useAvailabilities = (content, brand, urlVenue) => {
    var _a;
    const [availabilityState, setAvailabilityState] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        var _a;
        const contentId = content === null || content === void 0 ? void 0 : content.contentId;
        const locale = content === null || content === void 0 ? void 0 : content.locale;
        const isBookable = (content === null || content === void 0 ? void 0 : content.bookable) === true;
        const hasAvailability = Boolean((_a = content === null || content === void 0 ? void 0 : content.availability) === null || _a === void 0 ? void 0 : _a.availabilityState);
        if (!hasAvailability && brand && urlVenue && contentId && isBookable) {
            services_1.apiService.getAvailabilitiesForDS(locale, brand, urlVenue, [contentId]).then(availabilities => {
                if (availabilities && availabilities.length > 0) {
                    setAvailabilityState(availabilities[0].availabilityState);
                }
            });
        }
    }, [content === null || content === void 0 ? void 0 : content.locale, content === null || content === void 0 ? void 0 : content.contentId, content === null || content === void 0 ? void 0 : content.bookable, (_a = content === null || content === void 0 ? void 0 : content.availability) === null || _a === void 0 ? void 0 : _a.availabilityState, brand, urlVenue]);
    return availabilityState;
};
exports.default = useAvailabilities;
